import React, { PureComponent } from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import appDux from 'src/redux/app';
import uiDux from 'src/redux/ui';
import macheteDux from 'src/redux/machete';
import constants from 'src/constants';
import utils from 'src/utils';
import FacetAndFacadeCounter from 'src/components/DesignSidebar/FacetAndFacadeCounter';
import ElementStyleAttribute from './ElementStyleAttribute';
import {
  StyleEditorContainer,
  StyleEditorHeader,
  StyleEditorTitle,
  StyleAttributesContainer,
  StyleDivider,
  StyleFooter,
  StyleElementCountText,
} from './styled';

const { PATIO_DOOR_ID, SLIDING_GLASS_DOOR_ID, CATEGORIES } = constants.labels;
const { ELEMENT_STYLE_ATTRIBUTES, ELEMENT_PAINT_ATTRIBUTES } = constants.app;
const { shouldShowPaintMenu } = utils.designSidebar;

const mapStateToProps = (state, { style }) => ({
  material: macheteDux.selectors.getMaterialByIdProp(state, {
    materialId: style.materialId,
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleDesignStyleClick: uiDux.actions.handleDesignStyleClick,
    },
    dispatch,
  );

const isMaterialWallCategory = ({ category }) => category === CATEGORIES.WALLS;
const isMaterialDoorMaterial = ({ id }) =>
  [PATIO_DOOR_ID, SLIDING_GLASS_DOOR_ID].includes(id);
const filterMaterialIdAttribute = (attribute) =>
  attribute.property !== 'materialId';

export class ElementStyleEditor extends PureComponent {
  @autobind
  filterUnreadyAttrs(attrType) {
    return (attribute) => {
      const { style } = this.props;
      const attributes =
        attrType === 'paint'
          ? ELEMENT_PAINT_ATTRIBUTES
          : ELEMENT_STYLE_ATTRIBUTES;
      const previousAttrIndex = attributes.indexOf(attribute) - 1;
      const previousAttr = attributes[previousAttrIndex];
      const hasPreviousAttrSelection =
        previousAttr && !!style[previousAttr.property];

      return !previousAttr || hasPreviousAttrSelection;
    };
  }

  render() {
    const { handleDesignStyleClick, material, style } = this.props;
    const { productId } = style;
    const isWall = isMaterialWallCategory(material);
    const isDoor = isMaterialDoorMaterial(material);
    // material attribute is only choosable for doors and walls
    const shouldHideMaterialChoice = !(isWall || isDoor);
    const shownStyleAttributes = shouldHideMaterialChoice
      ? ELEMENT_STYLE_ATTRIBUTES.filter(filterMaterialIdAttribute)
      : ELEMENT_STYLE_ATTRIBUTES;

    return (
      <div>
        <StyleEditorContainer data-selenium="styleEditor">
          <StyleEditorHeader>
            <StyleEditorTitle
              onClick={() => handleDesignStyleClick(style)}
              data-selenium="StyleEditorTitleText"
            >
              {material.name}
            </StyleEditorTitle>
          </StyleEditorHeader>
          <StyleAttributesContainer>
            {shownStyleAttributes
              .filter(this.filterUnreadyAttrs('style'))
              .map((attribute) => (
                <ElementStyleAttribute style={style} attribute={attribute} />
              ))}
          </StyleAttributesContainer>

          {shouldShowPaintMenu(material.id, productId) && (
            <StyleAttributesContainer isPaint>
              {ELEMENT_PAINT_ATTRIBUTES.filter(
                this.filterUnreadyAttrs('paint'),
              ).map((attribute) => (
                <ElementStyleAttribute style={style} attribute={attribute} />
              ))}
            </StyleAttributesContainer>
          )}
          <StyleFooter>
            <StyleElementCountText>
              <FacetAndFacadeCounter styles={[style]} />
            </StyleElementCountText>
          </StyleFooter>
        </StyleEditorContainer>
        <StyleDivider />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ElementStyleEditor);
